import { HarmonyPackageFolderSchema } from '@rhythmic/types'
import type { CollectionBuildRequestConfig } from '../CollectionRegistry/CollectionBuilder.types'

export const HARMONY_PACKAGE_FOLDER_TABLE = '"public"."harmonyPackageFolders"'

export const HarmonyPackageFolderConfig: CollectionBuildRequestConfig = {
  collectionType: 'electric',
  table: HARMONY_PACKAGE_FOLDER_TABLE,
  partitionKey: 'package_id',
  key: 'id',
  apiEndpoint: '/api/harmony-package-folders',
  where: {},
  schema: HarmonyPackageFolderSchema,
}
